<template>
  <x-form xhr encoding="json" action="/rest/my_customers" :submit-text="$t('Invia')" :submit-help="`* ${$t('Campo obbligatorio')}`" @submit="onSubmit">
    <billing-form embed-for="prospect" />

    <pf-title h="3">{{ $t('Contatto') }}</pf-title>
    <pf-grid gutter>
      <pf-grid-item sm="6">
        <form-group :name="$t('Nome Contatto')" required>
          <x-input id="prospectFirstname" v-model="prospect.firstname" name="firstname" type="text" required maxlength="127" />
        </form-group>
      </pf-grid-item>
      <pf-grid-item sm="6">
        <form-group :name="$t('Cognome Contatto')" required>
          <x-input id="prospectLastname" v-model="prospect.lastname" name="lastname" type="text" required maxlength="127" />
        </form-group>
      </pf-grid-item>
    </pf-grid>
    <form-group :name="$t('Email (utilizzata anche come username)')" required>
      <x-input id="prospectEmail" v-model="prospect.email" name="email" type="email" required maxlength="127" />
    </form-group>
  </x-form>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import BillingForm from '../components/billing-form.vue';
import type { ComponentProps } from 'vue-component-type-helpers';
import type XForm from './x-form.vue';

type XFormProps = ComponentProps<typeof XForm>;

type Props = {
  cleanFields?: boolean;
  idProspect?: number;
} & /* @vue-ignore */ XFormProps;

withDefaults(defineProps<Props>(), {
  cleanFields: true,
});

const emit = defineEmits<{
  (name: 'submit', e: Event | undefined, response: any): void;
  (name: 'update:idProspect', value: number): void;
}>();

const prospect = ref<{
  firstname: string;
  lastname: string;
  email: string;
}>({
  firstname: '',
  lastname: '',
  email: '',
});

function onSubmit(e: Event | undefined, response: any) {
  emit('submit', e, response);
  emit('update:idProspect', response.id);
}
</script>
